/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ManagementMediumResponse { 
    id: string;
    nameCyrillic?: string;
    nameLatin?: string;
    type?: ManagementMediumResponse.TypeEnum;
}
export namespace ManagementMediumResponse {
    export type TypeEnum = 'PRINTED' | 'WEB' | 'TV' | 'RADIO' | 'SOCIAL';
    export const TypeEnum = {
        PRINTED: 'PRINTED' as TypeEnum,
        WEB: 'WEB' as TypeEnum,
        TV: 'TV' as TypeEnum,
        RADIO: 'RADIO' as TypeEnum,
        SOCIAL: 'SOCIAL' as TypeEnum
    };
}